import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraVillaCarlosPazPri from "../components/destinosSecciones/CabeceraVillaCarlosPazPri";
import HoteleriaCostaAtlanticaPrimario from "../components/hoteleria/HoteleriaCostaAtlanticaPrimario";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionCostaPri from "../components/diversion/DiversionCostaPri";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";

export default function PriCostaAtlantica() {
    return (
      <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/mardelplata/mar-del-plata.jpg"}
        HeaderTitle="Costa Atlántica"
        Parent="primarios"
        PageTitle="Costa Atlántica"
      />
      <CabeceraVillaCarlosPazPri destino={"Costa Atlántica"} />
      <VideoPromoDestino
        background="assets/img/costaAtlantica/mar-del-plata2.jpg"
        YoutubeVideoId="UyVWRKPntcI"
        TextoPromo="Conoce Costa Atlántica, tu viaje de egresados."
      />
      {/* Para cambiar hoteleria y Galeria */}
      <HoteleriaCostaAtlanticaPrimario />
      <DiversionCostaPri hasBg={true} />
      {/*  */}
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
      );

}